import { create } from "zustand";
import { devtools } from "zustand/middleware";

import { ContactDetailsDto } from "@hd/types/dto/contact/contact-details.dto";

export type RequestId = {
  contactId: number;
  requestDate: string;
};

interface RequestModalState {
  isOpen: boolean;
  step: number;
  contactDetails: ContactDetailsDto | null;
  companyId: number | null;
  requestId: RequestId | null;
  open: (
    step: number,
    contactDetails?: ContactDetailsDto | null,
    companyId?: number,
    requestId?: RequestId
  ) => void;
  setStep: (step: number) => void;
  close: () => void;
}

export const useRequestModalStore = create<RequestModalState>()(
  devtools((set) => {
    return {
      isOpen: false,
      step: 0,
      contactDetails: null,
      companyId: null,
      requestId: null,
      open: (step, contactDetails, companyId, requestId) => {
        set(() => ({
          isOpen: true,
          step,
          contactDetails: contactDetails ?? null,
          companyId: companyId ?? null,
          requestId: requestId ?? null,
        }));
      },
      setStep: (step) => {
        set(() => ({
          step,
        }));
      },
      close: () => {
        set(() => ({
          isOpen: false,
          step: 0,
          contactId: null,
          companyId: null,
          requestId: null,
        }));
      },
    };
  })
);
